<template>
    <p class="price"><input type="text" maxlength="250" class="edit-pen" :value="formattedPrice" v-on:input="updateValue"></p>
</template>

<script>
    export default {
        emits: ['update'],
        data() {
            return {
                formattedPrice: ""
            }
        },
        props: {
            id: String,
            price: Number // priceは数字として降りてきます
        },
        created() {
            // 数字をカンマ区切りのstringにします
            if(this.price > 0){
                this.formattedPrice = this.formatWithCommas(this.price);
            }
        },
        watch: {
            price: function (value) {
                if(value){
                    this.formattedPrice = this.formatWithCommas(value);
                }
                if(value == 0){
                    this.formattedPrice = 0;
                }
            },
        },
        methods: {
            updateValue(event){
                // 入力時valueをstringからコンマを抜けて数字に戻してから保存へemit
                let value;
                if(event.target.value.length == 0){
                    value = 0;
                } else {
                    value = parseFloat(event.target.value.replace(/,/g, ''));
                }
                // もしもなぜかマイナス金額を入力した場合対策
                value = Math.abs(value);
                this.$emit("update", this.id, value);
            },
            formatWithCommas(price){
                return Number(price).toLocaleString();
            }
        }
    }
</script>